/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Performancetable_Empty_Nodata_Description2Inputs */

const id_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penawaran ini belum muncul di bagan yang dilacak.`)
};

const ms_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tawaran ini belum muncul dalam mana-mana carta yang dikesan.`)
};

const da_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dette tilbud er ikke optrådt i nogen sporede diagrammer endnu.`)
};

const de_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Angebot ist noch nicht in verfolgten Charts aufgetaucht.`)
};

const en_us2_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This offer hasn't appeared in any tracked charts yet.`)
};

const es_es2_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta oferta no ha aparecido todavía en ningún ranking registrado.`)
};

const es_mx2_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay datos de rendimiento disponibles para esta colección.`)
};

const fil_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang offer na ito ay hindi pa lumalabas sa anumang na-track na chart.`)
};

const fr_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette offre de catalogue n'est encore apparue dans aucun classement.`)
};

const it_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa offerta non è ancora apparsa in alcuna classifica tracciata.`)
};

const hu_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ez az ajánlat még nem jelent meg egyetlen követett listán sem.`)
};

const nl_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit aanbod is nog niet verschenen in bijgehouden grafieken.`)
};

const no_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dette tilbudet har ikke dukket opp i noen sporede lister ennå.`)
};

const pl_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta oferta nie pojawiła się jeszcze na żadnym śledzonym wykresie.`)
};

const pt_br2_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta oferta de catálogo ainda não apareceu em nenhum gráfico rastreado.`)
};

const pt_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta oferta ainda não apareceu em nenhum gráfico registado.`)
};

const ro_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Această ofertă nu a apărut încă în niciun clasament urmărit.`)
};

const fi_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tämä tarjous ei ole vielä esiintynyt missään seuratuissa listoissa.`)
};

const sv_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detta erbjudande har inte förekommit i några spårade listor än.`)
};

const vi_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ưu đãi này chưa xuất hiện trong bất kỳ bảng xếp hạng nào được theo dõi.`)
};

const tr_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu teklif henüz izlenen hiçbir listede görünmedi.`)
};

const cs_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tato nabídka se dosud neobjevila v žádném sledovaném žebříčku.`)
};

const bg_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тази оферта не се е появявала в никоя проследявана класация.`)
};

const ru_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Это предложение ещё не появлялось в отслеживаемых чартах.`)
};

const uk_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ця пропозиція ще не з'являлася в жодному відстежуваному чарті.`)
};

const ar_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يظهر هذا العرض في أي مخططات متعقبة بعد.`)
};

const hi_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह ऑफ़र अभी तक किसी ट्रैक किए गए चार्ट में नहीं दिखा है।`)
};

const th_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อเสนอนี้ยังไม่ปรากฏในแผนภูมิที่ติดตามใด ๆ`)
};

const ja_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このオファーはまだ追跡チャートに登場していません。`)
};

const zh_cn2_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此目录项尚未出现在任何追踪榜单中。`)
};

const zh_hant1_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此目錄項目尚未出現在任何已追蹤的排行榜中。`)
};

const ko_components_performancetable_empty_nodata_description2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 오퍼는 아직 추적 중인 차트에 나타난 적이 없습니다.`)
};

/**
* | output |
* | --- |
* | "This offer hasn't appeared in any tracked charts yet." |
*
* @param {Components_Performancetable_Empty_Nodata_Description2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_performancetable_empty_nodata_description2 = /** @type {((inputs?: Components_Performancetable_Empty_Nodata_Description2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Performancetable_Empty_Nodata_Description2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "ms") return ms_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "da") return da_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "de") return de_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "en-US") return en_us2_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "es-ES") return es_es2_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "es-MX") return es_mx2_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "fil") return fil_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "fr") return fr_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "it") return it_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "hu") return hu_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "nl") return nl_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "no") return no_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "pl") return pl_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "pt-BR") return pt_br2_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "pt") return pt_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "ro") return ro_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "fi") return fi_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "sv") return sv_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "vi") return vi_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "tr") return tr_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "cs") return cs_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "bg") return bg_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "ru") return ru_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "uk") return uk_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "ar") return ar_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "hi") return hi_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "th") return th_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "ja") return ja_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_performancetable_empty_nodata_description2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_performancetable_empty_nodata_description2(inputs)
	return ko_components_performancetable_empty_nodata_description2(inputs)
});
export { components_performancetable_empty_nodata_description2 as "components.performanceTable.empty.noData.description" }